// Комментарии на русском: принудительная очистка клиентских кэшей/хранилищ.
// Зачем: после деплоя избежать конфликтов старых данных (CacheStorage/localStorage/sessionStorage) с новым UI.

const BUILD_KEY = 'lisad_app_build_id_v1';
const KEEP_KEYS = new Set(['access', 'refresh', 'user', BUILD_KEY, 'lisad.site-theme.guest.v1']);

// Комментарий на русском: какие CacheStorage-кэши НЕ удаляем при деплое.
// Зачем: это офлайн-данные (PWA), настройки push-уведомлений и кэш голосовых — они не конфликтуют с обновлением UI.
const KEEP_CACHE_PREFIXES = ['lisad_pwa_', 'lisad_push_prefs_', 'lisad_voice_', 'lisad_chat_'];

export async function purgeSiteCache(): Promise<void> {
  try {
    // Cache Storage (удаляем только "чужие" кэши; наши офлайн/voice/push — сохраняем)
    try {
      if (typeof caches !== 'undefined') {
        const keys = await caches.keys();
        await Promise.all(
          keys
            .filter((k) => !KEEP_CACHE_PREFIXES.some((p) => k.startsWith(p)))
            .map((k) => caches.delete(k))
        );
      }
    } catch {
      // ignore
    }

    // localStorage
    try {
      if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
        const toDelete: string[] = [];
        for (let i = 0; i < localStorage.length; i++) {
          const k = localStorage.key(i) || '';
          if (!k || KEEP_KEYS.has(k)) continue;
          toDelete.push(k);
        }
        toDelete.forEach((k) => localStorage.removeItem(k));
      }
    } catch {
      // ignore
    }

    // sessionStorage (Next хранит там скролл/навигацию)
    try {
      if (typeof window !== 'undefined' && typeof sessionStorage !== 'undefined') {
        const toDelete: string[] = [];
        for (let i = 0; i < sessionStorage.length; i++) {
          const k = sessionStorage.key(i) || '';
          if (!k || KEEP_KEYS.has(k)) continue;
          toDelete.push(k);
        }
        toDelete.forEach((k) => sessionStorage.removeItem(k));
      }
    } catch {
      // ignore
    }
  } catch {
    // ignore
  }
}

export function getStoredBuildId(): string {
  try {
    if (typeof window === 'undefined') return '';
    return String(localStorage.getItem(BUILD_KEY) || '');
  } catch {
    return '';
  }
}

export function setStoredBuildId(buildId: string): void {
  try {
    if (typeof window === 'undefined') return;
    const v = String(buildId || '');
    if (!v) return;
    localStorage.setItem(BUILD_KEY, v);
  } catch {
    // ignore
  }
}


